import React from 'react';

const NotFound: React.FC = () => (
  <p className="m-auto text-lg">
    Sorry, we can&apos;t seem to find the page you are looking for. Please try
    again.
  </p>
);
export default NotFound;
